import mixpanel from 'mixpanel-browser';
import config from 'config/config';

mixpanel.init(config.MIX_PANEL_TOKEN, { persistence: 'localStorage' });

export const AnalyticsProvider = {
  identify: id => {
    mixpanel.identify(id);
  },
  alias: id => {
    mixpanel.alias(id);
  },
  track: (name, props = {}) => {
    mixpanel.track(name, props);
  },
  people: {
    set: props => {
      mixpanel.people.set(props);
    }
  },
  register: data => {
    mixpanel.register(data);
  },
  initializePeople: user => {
    mixpanel.identify(user.id);
    mixpanel.people.set({
      $email: user.email,
      $name: user.displayName,
      $username: user.username
    });
  },
  initializeSpotSuperProps: spot => {
    if (!spot) {
      return;
    }
    mixpanel.register({
      spot_name: spot.name,
      spot_id: spot.id,
      user_role: spot.role
    });
  }
};
